<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filters" class="filter-panel fl">
			</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add()" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border row-key="id" size="mini" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
			<el-table-column prop="title" align="center" :label="$t('adv_index.title')"></el-table-column>
			<el-table-column prop="description" align="center" :label="$t('adv_index.description')"></el-table-column>
			<el-table-column prop="type" align="center" :label="$t('adv_index.type')"></el-table-column>
			<el-table-column prop="image" align="center" :label="$t('adv_index.image')">
				<template slot-scope="scope">
					<el-image style="width: 100px; height: 100px" v-if="scope.row.image" :src="scope.row.image" :preview-src-list="[scope.row.image]" fit="contain"></el-image>
					<span v-if="!scope.row.image">{{$t('index.image_wu')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.dialog_title')" width="900px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="8">
						<el-form-item :label="$t('adv_index.title')" prop="title">
							<el-input v-model="editForm.title" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('adv_index.description')" prop="description">
							<el-input v-model="editForm.description" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('adv_index.type')" prop="type">
							<el-input v-model="editForm.type" :placeholder="$t('index.pleaseInput')" class="w100"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('adv_index.course_type')" prop="course_type" data-name="课程类型">
							<el-select v-model="editForm.course_type" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('adv_index.course_id')" prop="course_id">
							<el-input v-model="editForm.course_id" :placeholder="$t('index.pleaseInput')" class="w100"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="tree-content" :gutter="20">
					<el-col :span="8">
						<el-form-item :label="$t('adv_index.image')" prop="image">
							<upload :value="editForm.image" @callback="function(res, file){imageSuccess(res, file,'image')}"></upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			image_up: process.env.API_UP,
			list: [],
			editFormVisible: false,
			editForm: {
				title: '',
				description: '',
				type: '',
				image: '',
			},
			image: '',
			editFormRules: {
				image: [{
					required: true,
					message: this.$t('adv_index.message'),
					trigger: 'blur'
				}],
				type: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('adv_index.type'),
					trigger: 'blur'
				}],
			},
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			filters: {},
			DATA_RIGHTS: [],
			TYPE: [],
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
		this.config();
		console.log(this.$t('index.submit'));
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: "DATA_RIGHTS,TYPE"
			};
			this_.$post(url, datas).then((res) => {
				this_.DATA_RIGHTS = res.DATA_RIGHTS;
				this_.TYPE = res.TYPE;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "AdvList";
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		add(data) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					title: '',
					description: '',
					type: '',
					image: '',
					course_type: '',
					course_id: '',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						title: this_.editForm.title,
						description: this_.editForm.description,
						country: 'us',
						type: this_.editForm.type,
						course_type: this_.editForm.course_type,
						course_id: this_.editForm.course_id,
					}
					if (this_.image) {
						datas['image'] = this_.image;
					}
					var url = "AdvAction";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		imageSuccess(res, file, name) {
			if (res.status == 200) {
				this.editForm[name] = res.data.showname;
				this.image = res.data.savename;
				this.$refs.editForm.clearValidate(name);
			} else {
				this.$message.success(res.message);
			}
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "AdvDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		type_f(w, s, d) {
			var type_data = this.type_data;
			var name = '';
			type_data.forEach(function (e, i) {
				if (e.value == d) {
					name = e.name;
				}
			});
			return name
		},
		// 搜索
		sousuo() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		chongxzhi() {
			this.filters.type = '';
			this.pages.page = 1;
			this.init();
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/adv/index.vue